<template>
  <div class="content-btn-check">
    <button class="sure-desc-check widthmax" :disabled="btnDisable"
            @click="commitReport">创建访问报告</button>
            <van-popup v-model="loading" style="background-color:rgb(0,0,0,0);overflow:hidden" :close-on-click-overlay="false"><van-loading color="white" size="1.1rem"/></van-popup>
            
  </div>
</template>

<script>
import reportModel from '../../api/model/visit-report'
import smsModel from '../../api/model/sms'
//import visitPlanModel from "../../api/model/visit-plan"
import { mapState } from 'vuex'
export default {
  data() {
    return {
      btnDisable:false,
      loading:false
    }
  },
  name: 'SubmitReport',
  methods: {
    async commitReport() {
      if (this.reportData.custId <= 0) {
        this.$toast('请先通过搜索确认客户后再继续此操作')
      } else if (this.reportData.visitDate == '') {
        this.$toast('请选择访问日期后再继续此操作')
      } else if (this.reportData.nextVisitDate == '') {
        this.$toast('请选择下次访问日期后再继续此操作')
      } else if (this.reportData.visitReason == '') {
        this.$toast('请选择访问原因后再继续此操作')
      } else if (this.reportData.visitWayCode == '') {
        this.$toast('请选择访问方式后再继续此操作')
      } else if (this.reportData.visiter.mainVisiter.length == 0) {
        this.$toast('请添加一个主访人后再继续此操作')
      } else if (this.reportData.visitResult == '') {
        this.$toast('请填写访谈记录后再继续此操作')
      } else if (
        this.rolePowers.indexOf(this.RoleType.mutiBranch) != -1 &&
        this.reportData.salCode == ''
      ) {
        this.$toast('请选择一个销售员后再继续此操作')
      } else {
        this.reportData.visiter.mainVisiter.forEach((item) => {
          if(item.name==''){
            this.$toast('请选择一个主访人后再进行操作')
            return false;
          }
        })
        this.loading=true
        this.btnDisable=true
        const res = await reportModel.addNewReport(this.reportData, null)
        if (res.success) {
          this.loading=false
          this.btnDisable=false
          //   if(this.reportData.planid!=0){  //访问计划转报告的一步
          //   var planres=await visitPlanModel.addReportByPlan({
          //     reportid:res.data.vstprtid,
          //     planid:this.reportData.planid
          //   })
          //   if(planres.success)
          //   {
          //     this.$toast('访问计划转访问报告添加成功')
          //   }else{
          //     this.$toast(res.msg)
          //   }
          // }

          var msgRes = await smsModel.sendApproveMessage(null, {
            type: this.approveParam.visitReport,
          })
          if (msgRes.success) {
            this.$toast('访问报告添加成功')
          } else {
            this.$toast('访问报告添加成功,短信发送失败')
          }
          this.$router.push({ path: '/home' })
        } else {
          this.loading=false
          this.btnDisable=false
          this.$toast(res.msg)
        }
      }
    },
  },
  props: ['reportData'],
  computed: {
    ...mapState('systemAbout', ['approveParam', 'RoleType']),
    ...mapState('userAbout', ['rolePowers']),
  },
}
</script>

<style scoped>
</style>